module.exports = __webpack_public_path__ + "img/bullet_5.f268a653.svg";